import lodashIsEqual from 'lodash/isEqual';
import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from '@/store/global-store-base';
import type { CompositionMaterialDetailSimple } from '@/ApiClient';

export const useMaterials = defineStore('materials', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.compositionMaterial_GetCompositionMaterials,
    dto: 'CompositionMaterialDto',
    create: api.compositionMaterial_AddCompositionMaterial,
    update: api.compositionMaterial_UpdateCompositionMaterial,
    delete: api.compositionMaterial_DeleteCompositionMaterial,
    signalR: 'MaterialUpdate',
  });
  const { loaded } = globalStoreBase;

  async function create(newMaterialName: string, details: CompositionMaterialDetailSimple[]) {
    const existingMaterialWithSameName = loaded.value.find(
      (material) =>
        material.name?.toLowerCase() === newMaterialName.toLowerCase() && lodashIsEqual(material.details, details)
    );

    if (existingMaterialWithSameName) {
      return existingMaterialWithSameName;
    }

    return await globalStoreBase.create({ name: newMaterialName, details });
  }

  function materialsMatchingQuery(queryString: string) {
    return loaded.value.filter(
      (m) =>
        m.name?.toLowerCase().includes(queryString?.toLowerCase()) ||
        m.details?.map((d) => d.value).some((v) => v?.toLowerCase().includes(queryString?.toLowerCase()))
    );
  }

  return {
    ...globalStoreBase,
    loaded,
    create,
    materialsMatchingQuery,
  };
});
